import { useSelector } from 'react-redux';
import { RootState } from '../../Store/Store';

/**
 * Whether the current user has general access to the storefront (can browse and start
 * new carts), as opposed to being granted access only to view a specific prepared cart.
 *
 * Fails open: returns true unless the session explicitly reports no general access, so
 * legacy sessions (and the brief window before the session loads) are not locked out.
 */
export function useHasGeneralStorefrontAccess(): boolean {
    return useSelector(
        (state: RootState) => state.auth.session?.hasGeneralStorefrontAccess !== false
    );
}
